// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bJ","header":"bK","title":"bL","description":"bM","button":"bN"};